import { Link, useRouteError } from "react-router-dom";
import { useDocumentMeta } from "../lib/useDocumentMeta";

export function ErrorPage() {
  useDocumentMeta("Something Went Wrong", undefined, undefined, undefined, { noindex: true });
  const error = useRouteError();
  const message = error instanceof Error ? error.message : undefined;

  return (
    <main className="max-w-2xl mx-auto px-6 py-32 text-center flex flex-col items-center gap-6">
      <span className="text-sm font-medium text-accent tracking-[0.2em] uppercase">Error</span>
      <h1 className="text-display-md">Something went wrong.</h1>
      <p className="text-ink-muted leading-relaxed max-w-md">
        This wasn't your fault — the page hit an unexpected error. Try refreshing, or head back to the homepage.
      </p>
      {import.meta.env.DEV && message && (
        <pre className="text-left text-xs text-red-500 bg-surface border border-border rounded-xl p-4 max-w-full overflow-x-auto">
          {message}
        </pre>
      )}
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="inline-flex items-center gap-2 h-12 px-7 rounded-full border border-border text-sm font-medium hover:bg-surface transition-colors duration-300 ease-physical"
        >
          Refresh
        </button>
        <Link
          to="/"
          className="inline-flex items-center gap-2 h-12 px-7 rounded-full bg-ink text-canvas text-sm font-medium hover:bg-accent hover:text-ink transition-colors duration-300 ease-physical dark:bg-accent dark:text-ink"
        >
          Back to the homepage
        </Link>
      </div>
    </main>
  );
}
